export const REQUIRED = 'required'
export const OPTIONAL = 'optional'

export const ADD_MODE = 'add'
export const EDIT_MODE = 'edit'
